import React from 'react';
import NinjaGame from '../NinjaGame';
import { ALL_DRILLS } from '../DrillConstants';

const Click6Ninja = () => {
    const idx = ALL_DRILLS.findIndex(d => d.id === 'click-6-random');
    return <NinjaGame initialDrillIndex={idx} />;
};

export default Click6Ninja;
